import { FileButton as MantineFileButton } from "@mantine/core";

export const FileButton = MantineFileButton;
